const appData = {
  "appDomain": "http://0.0.0.0:3000",
  "appUrl": "http://0.0.0.0:3000",
  "publicUrl": "http://0.0.0.0:3000",
  "publicRoutePath": "http://0.0.0.0:3000",
  "gseoClient": "gseoreferral",
  "gseoRecaptcha": "6LfSxMMaAAAAAGziyyYOEc7MosJoqW8j0nj2j0dP",
  "analyticsUA": "UA-3195472-57",
  "ga4_id": "G-NEFBC77K8L"
};
export {appData};
